var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TOOL_UP"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-362",
    x: 8.0795,
    y: 9.07979,
    width: 43.841,
    height: 43.841,
    rx: 10,
    ry: 10,
    transform: "translate(-13.13371 30.29298) rotate(-45)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "frm_3-372",
    x: 9.70734,
    y: 8.38636,
    width: 40.58535,
    height: 40.58535,
    rx: 10,
    ry: 10,
    transform: "translate(-11.49234 29.61311) rotate(-45)",
    fill: "#f59e00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.02615,17.78074h-1.81586c-.01903-.00063-.03687-.00565-.05604-.00565h-.78399v-.6595h-16.94434v.6595h-.9057c-.01917,0-.03701.00502-.05604.00565h-1.81579v3.46652h2.77754v.64786h6.69848v11.10047c0,.34993-.28364.63364-.63364.63364h-.44578c-.35,0-.63371.28371-.63371.63364v8.34001c0,.34993.28371.63364.63371.63364h.58331v1.2122h4.63021v-1.2122h.37216c.35,0,.63364-.28371.63364-.63364v-8.34001c0-.34993-.28364-.63364-.63364-.63364h-.44578c-.35,0-.63371-.28371-.63371-.63364v-11.10047h6.81907v-.64786h2.6559v-3.46652Z",
    fill: "#82368c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolUpIcon);
export default __webpack_public_path__ + "static/media/ToolUpIcon.a2c8e395c1967f6cf610da44445b5f72.svg";
export { ForwardRef as ReactComponent };